import { render, staticRenderFns } from "./Watchdetail-child3.vue?vue&type=template&id=b01a2906&scoped=true"
import script from "./Watchdetail-child3.vue?vue&type=script&lang=js"
export * from "./Watchdetail-child3.vue?vue&type=script&lang=js"
import style0 from "./Watchdetail-child3.vue?vue&type=style&index=0&id=b01a2906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01a2906",
  null
  
)

export default component.exports